import { useState } from "react";
import { Button } from "react-bootstrap";

type Props = {
    show?: boolean;
    text: string | number | undefined;
}

export default function Copy({
    show = true,
    text,
}: Props) {
    const [copied, setCopied] = useState(false);

    const handleCopy = (text: string | number | undefined) => {
        navigator.clipboard.writeText(String(text));
        setCopied(true);
        delay(2000).then(() => setCopied(false));
    }

    const delay = (milliseconds: number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    }

    if (!show) {
        return null;
    }
    return (
        <Button onClick={() => handleCopy(text)}>
            Copy &nbsp;
            {copied ? <i className="bi bi-check-lg"></i> : <i className="bi bi-copy"></i>}
        </Button>
    );
}